import React, { useEffect } from 'react'
import { BaseCard } from '@verifier-user/verifier-headless-ui'
import { InfoCDR } from '@verifier-user/verifier-cdr'
import { useApplicationContext } from '../../contexts/appContext'

export const IncomeSuccess = () => {
  const { expire } = useApplicationContext()
  useEffect(() => {
    expire()
  }, [])

  return (
    <>
      <h1 className={'text-4xl sm:text-5xl mb-8 leading-tight'}>Congratulations</h1>

      <BaseCard className='mt-0 max-w-screen-md mb-8' data-testid='success-content'>
        <p data-testid='success-content-par-1'>Thank you, your income verification is complete.</p>
      </BaseCard>

      <InfoCDR
        accreditationLink={process.env.ACCREDITATION_LINK}
        accreditationNumber={process.env.ACCREDITATION_NUMBER}
        companyName={process.env.COMPANY}
      ></InfoCDR>
    </>
  )
}
